import { Component, Mixins } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { AppHypotheekMixin } from '../../mixins/AppHypotheekMixin';

@Component
export default class AppWijzigenAdviseur extends Mixins(AppHypotheekMixin) {
  @State(state => state.config.ppfAdviseurZoekenUrl)
  public ppfAdviseurZoekenUrl!: string;
}
